import { NoticesFeed } from '@/features/announcements/components/NoticesFeed'

/** Recipient notice board, mounted in every portal. */
export function NoticesPage({ homeHref }: { homeHref: string }) {
  return <NoticesFeed homeHref={homeHref} />
}
